const FrameworkTestKeys = Object.seal({
  settingsToggle: 'settingsToggle',
  settingsToggleContainer: 'settingsToggleContainer',
  settingsToggleContainerView: 'settingsToggleContainerView',
  settingsToggleIcon: 'settingsToggleIcon',
  settingsToggleTitleView: 'settingsToggleTitleView',
  settingsToggleTitleText: 'settingsToggleTitleText',
  settingsToggleDescriptionText: 'settingsToggleDescriptionText',
  settingsRadioButton: 'settingsRadioButton',
  settingsRadioView: 'settingsRadioView',
  settingsRadioTextView: 'settingsRadioTextView',
  settingsRadioIcon: 'settingsRadioIcon',
  settingsRadioTitleText: 'settingsRadioTitleText',
  AppSettingsCloseBtn: 'appSettingsCloseBtn',
  AppSettingsScroll: 'appSettingsScroll',
  AppPermissionsViewCloseButton: 'closeButtonAppPermissionsView',
  AppPermissionsViewBackButton: 'backButtonAppPermissionsView',
  DPTapSettings: 'DPtapSettings',
  DPFooterText: 'DPfooterText',
  BackBtn: 'backBtn',
  CloseBtn: 'closeBtn',
  PermissionTitle: 'permissionTitle',
  PreOnboardingLottieView: 'preOnboardingLottieView',
  PreOnboardingRegisterButton: 'preOnboardingRegisterButton',
  LoginLoginTutorial: 'loginLoginTutorial',
  PreOnboardingPagination: 'preOnboardingPagination',
  PreOnboardingCard: 'preOnboardingCard',
  PreOnboardingCardCarouselTitle: 'preOnboardingCardCarouselTitle',
  PreOnboardingCardCarouselDescription: 'preOnboardingCardCarouselDescription',
  AddPaymentCloseButton: 'add_payment_close_button',
  PaymentMethodsView: 'paymentMethodsView',
  SaveCardBtn: 'saveCardBtn',
  CardNameRightIcon: 'cardNameRightIcon',
  CardNameHelperText: 'cardNameHelperText',
  CardName: 'cardName',
  CvvNoHelperText: 'cvvNoHelperText',
  CvvNo: 'cvvNo',
  ExpiryDateRightIcon: 'expiryDateRightIcon',
  ExpiryDate: 'expiryDate',
  NameOnCardRightIcon: 'nameOnCardRightIcon',
  NameOnCardHelperText: 'nameOnCardHelperText',
  NameOnCard: 'nameOnCard',
  CardNoRightIcon: 'cardNoRightIcon',
  CardNoHelperText: 'cardNoHelperText',
  CardNo: 'cardNo',
  AddPaymentCardView: 'addPaymentCardView',
  SaveCardForLaterToggle: 'saveCardForLaterToggle',
  AddPaymentView: 'addPaymentView',
  PreferedCardID: 'preferedCardID',
  AddNewCardBtn: 'addNewCardBtn',
  OBYesButton: 'OByesButton',
  TopUpPaymentEditBtn: 'topUpPaymentEditBtn',
  TPMainIcon: 'TPmainIcon',
  TopUpPaymentFooter: 'topUpPaymentFooter',
  PaymentErrorTitle: 'paymentErrorTitle',
  TPPaymentCard: 'TPpaymentCard',
  TopUpPaymentCardListScrollView: 'topUpPaymentCardListScrollView',
  TPDefaultPaymentCard: 'TPdefaultPaymentCard',
  ContactListIconTestID: 'contactListIconTestID',
  LoginPhoneTxt: 'loginPhoneTxt',
  TextinputError: 'textinput_error',
  IcRedTriangle: 'ic_red_triangle',
  CurrencySymbol: 'currency_symbol',
  CustomAmount: 'customAmount',
  TopUpAddCardBtn: 'topUpAddCardBtn',
  GroupDataPlanBtn: 'groupDataPlanBtn',
  AddMemberModal: 'addMemberModal',
  AddMemberSectionHeader: 'addMemberSectionHeader',
  CvvNumber: 'cvvNumber',
  RemoveMemberModal: 'removeMemberModal',
  RemoveMemberIcon: 'removeMemberIcon',
  AddDataModal: 'addDataModal',
  PaymentSuccess: 'paymentSuccess',
  PaymentLoading: 'paymentLoading',
  AddMemberInput: 'addMemberInput',
  DeviceCapacityItem: 'DeviceCapacityItem',
  DeviceColorItem: 'DeviceColorItem',
  AccordionDeviceSectionHeader: 'AccordionDeviceSectionHeader',
  TobiMessage: 'tobiMessage',
  TrayTobiIcon: 'trayTobiIcon',
  TrayCustomIcon: 'trayCustomIcon',
  TrayLottieContainer: 'trayLottieContainer',
  TobiModalCloseBtn: 'tobiModalCloseBtn',
  SubTrayGroupScroll: 'subTrayGroupScroll',
  AnimationView: 'animationView',
  Description: 'description',
  DescriptionView: 'description',
  EIOCloseButtonView: 'EIOcloseButton',
  EIOCloseButton: 'EIOcloseButton',
  DBHeaderTitle: 'DBheaderTitle',
  DBHeaderSubTitle: 'DBheadersubTitle',
  VfLogo: 'vfLogo',
  DBHeaderLayout: 'DBheaderLayout',
  EIOFixButton: 'EIOfixButton',
  EIOWarningDesc: 'EIOwarningDesc',
  SubItem: 'subItem',
  IconContainer: 'iconContainer',
  EIOWarningIcon: 'EIOwarningIcon',
  EIOCheckIcon: 'EIOcheckIcon',
  SubItemText: 'subItemText',
  DSIcon: 'DSIcon',
  EIODetailsPageResult: 'EIOdetailsPageResult',
  DashboardMainScroll: 'DashboardMainScroll',
  DBErrorIcon: 'DBerrorIcon',
  DBErrorArrow: 'DBerrorArrow',
  DBErrorDescription: 'DBerrorDescription',
  DBErrorTryAgainText: 'DBerrorTryAgainText',
  WebViewCloseBtn: 'webViewCloseBtn',
  WebViewReloadBtn: 'webViewReloadBtn',
  WebViewBackBtn: 'webViewBackBtn',
  WebView: 'webView',
  SwitchAccountCancelCTA: 'switchAccountCancelCTA',
  AccountItemTestID: 'AccountItemTestID',
  SwitchAccountOtherAccountsTitle: 'switchAccountOtherAccountsTitle',
  SwitchAccountCurrentAccountTitle: 'switchAccountCurrentAccountTitle',
  SwitchAccountView: 'switchAccountView',
  SwitchAccountCloseIcon: 'switchAccountCloseIcon',
  SwitchAccountTitle: 'switchAccountTitle',
  SwitchAccountQuickActionMainView: 'switchAccountQuickActionMainView',
  OBNotNowButton: 'OBnotNowButton',
  OBAndroidSettings: 'OBandroidSettings',
  SecondPermissionStepDescription: 'secondPermissionStepDescription',
  PPOAcceptButton: 'PPO-Accept-Button',
  PPOOverlayButton: 'PPO-Overlay-Button',
  PPORejectButton: 'PPO-Reject-Button',
  PPOAcceptButtonIntro: 'PPO-Accept-Button',
  PPOReadButton: 'PPO-Read-Button',
  PPOXIcon: 'PPOXIconIcon',
  PPOBackButton: 'PPO-Back-Button',
  PPOProcessing: 'PPO-Processing',
  PPOSuccess: 'PPO-Success',
  PPOFail: 'PPO-Fail',
  permissionsItem: 'permissionsItem',
  PPOMoreButton: 'PPO-More-Button',
  OBHappyButton: 'OBhappyButton',
  OBPermissionsStepDesc: 'OBpermissionsStepDesc',
  LogOutQACancelBtn: 'logOutQACancelBtn',
  LogOutQALogOutBtn: 'logOutQALogOutBtn',
  LogOutQA: 'logOutQA',
  ChangeDeviceNameVFInput: 'ChangeDeviceName_VFInput',
  BackgroundViewVfTitle: 'vfTitle',
  BackgroundViewVfLogo: 'vfLogo',
  BackgroundLocationOverlay: 'backgroundLocationOverlayTestID',
  CloseIcon: 'CloseIconTestID',
  FailureModal: 'FailureModalAccessibilityLabel',
  ConfirmButton: 'ConfirmButton',
  ConfirmPasswordID: 'ConfirmPasswordID',
  NewPasswordID: 'NewPasswordID',
  CurrentPasswordID: 'CurrentPasswordID',
  ChangePasswordDescriptionID: 'ChangePasswordDescriptionID',
  ChangePasswordSubtitleID: 'ChangePasswordSubtitleID',
  ChangePasswordCloseIcon: 'CloseIcon',
  CloseButton: 'CloseButton',
  BookAppointmentCloseButton: 'BookAppointmentCloseButton',
  BookAnAppointmentSteps: 'BookAnAppointmentSteps',
  SelectDateButton: 'SelectDateButton',
  StoresCardsListFlatList: 'FlatListTestID',
  ShowTimeSlotButton: 'ShowTimeSlotButton',
  NoAppointmentsDesc: 'DescTestID',
  NoAppointmentsSubTitle: 'SubTitleTestID',
  NoAppointmentsTitle: 'TitleTestID',
  BalanceHistory: 'BalanceHistoryTestID',
  CloseButtonMyAddress: 'CloseButtonMyAddress',
  AddressScreenCloseButton: 'CloseButtonTestID',
  ChangeAddressModelButton: 'changeAddressModelButton',
  ChangeAddressModelTitle: 'changeAddressModelTitle',
  ChangeAddressView: 'changeAddressView',
  ChangeAddressSpinner: 'changeAddressSpinner',
  ChangeAddressScrollView: 'changeAddressScrollView',
  ChangeAddressTitleAccessibilityLabel: 'change_address_title_accessibility_label',
  SaveAddressBtn: 'saveAddressBtn',
  City: 'city',
  StreetName: 'streetName',
  HouseOrFlat: 'houseOrFlat',
  PostCode: 'postCode',
  ChangeAddressFormView: 'ChangeAddressFormView',
  AddOnsShopScreenClose: 'AddOnsShopScreenClose',
  AddonsListScroll: 'addonsListScroll',
  AddOnDetailsActionBtn: 'AddOnDetailsActionBtn',
  AddOnDetailsButtonLabel: ' button label',
  AddOnDetailsBackcButton: 'backcButtonAddOnsView',
  AddOnDetailsCloseButton: 'closeButtonAddOnsView',
  AddOnDetailsTitleId: ' title id',
  AddOnDetailsCloseButtonLabel: ' close button label',
  AddOnDetailsBackButtonLabel: ' back button label',
  AddOnDetailsExpirationContainer: ' expiration container',
  AddOnDetailsDescription: ' description',
  AddOnDetailsSubtitleLabel: ' subtitle label',
  ConfirmationMenuSecondaryBtn: 'confirmationMenuSecondaryBtn',
  ConfirmationMenuPrimaryBtn: 'confirmationMenuPrimaryBtn',
  ConfirmationMenuPrimaryButtonTextLabel: 'primary button text label',
  ConfirmationMenuSecondaryButtonTextLabel: 'secondary button text label',
  AddOn: ' add-on',
  BuyAddOnsButton: 'Buy Add-ons button',
  PPOReturnDashboard: 'PPO-Return-Dashboard',
  PPOManagePrivacy: 'PPO-Manage-Privacy',
  PPOTryAgain: 'PPO-Try-Again',
  SubTrayItemViewDescription: 'Description',
  SubTrayItemViewSubTitle: 'SubTitle',
  SubTrayItemViewIcon: 'Icon',
  SubTrayItemViewTitle: 'Title',
  SubTrayItemViewInnerContainer: 'InnerContainer',
  ModalConfirm: 'modalConfirm',
  ModalCancel: 'modalCancel',
  AddData: 'addData',
  IncreaseDataButton: 'increaseDataButton',
  ReduceDataButton: 'reduceDataButton',
  ConfirmPayment: 'confirmPayment',
  UserUnusedData: 'userUnusedData',
  UserTotalData: 'userTotalData',
  AvailableData: 'availableData',
  ManageDataPlanConfirmButton: 'confirmButton',
  ModalChangedData: 'modalChangedData',
  ModalAvailableData: 'modalAvailableData',
  AddressCardDescription: 'AddressCardDescription',
  DiscoverCardContainerIsLoading: 'discoverCardContainer',
  DiscoverCardContainerLoadingError: 'discoverCardContainer',
  DiscoverCardContainer: 'discoverCardContainer',
  DBbasicsShowMore: 'DBbasicsShowMore',
  DBmainCard: 'DBmainCard',
  DBsecCard1: 'DBsecCard1',
  DBsecCard2: 'DBsecCard2',
  DBsecCard3: 'DBsecCard3',
  DBdiscoverTitle: 'DBdiscoverTitle',
  ErrorIcon: 'ErrorIcon',
  ErrorText: 'ErrorText',
  ErrorTryAgainText: 'ErrorTryAgainText',
  ErrorArrow: 'ErrorArrow',
  TrayHocST: 'ST',
  TrayHocItem: 'Item',
  ButtomTray: 'tray',
  ButtomTrayView: 'trayView',
  CollapseIcon: 'collapseIcon',
  QuickActionMainView: 'quickActionMainView',
  MakePreferred: 'make_preferred',
  AddressCardDescriptionText: 'AddressCardDescription',
  MainCard: 'mainCard',
  SupTrayErrorDescription: 'description',
  SupTrayErrorDescriptionView: 'description',
  QuickActionMenuTitleLabel: 'QuickActionMenu title label',
  QuickActionMenuCloseIconLabel: 'QuickActionMenu close icon label',
  ChangeAddressButton: 'ChangeAddressButton',
  BookAppointmentButton: 'BookAppointmentButton',
  YourAppointments: 'YourAppointments',
  SummaryStepConfirm: 'Confirm',
  FailureModalTryAgain: 'TryAgain',
  ConnectedAppsItem: 'Item',
  ConnectedAppsButton: 'Button',
  ConnectedAppsIcon: 'Icon',
  ConnectedAppsTitle: 'Title',
  GroupCard: 'GroupCard',
  GroupCardIcon: 'Icon',
  GroupCardTxt: 'Txt',
  GroupCardArrow: 'Arrow',
  DashboardContainerView: 'View',
  DashboardContainerTitle: 'Title',
  DashboardContainerSection: 'Section',
  DBotherAppsView: 'DBotherAppsView',
  DBotherAppsTitle: 'DBotherAppsTitle',
  DBotherAppsSection: 'DBotherAppsSection',
  MyProductsHeaderPaygTopupButtonTitleLabel: 'my_products_header_payg_topup_button_title_label',
  MyProductsHeaderPaygTopupButtonTitleLabelProductsAndServices:
    'my_products_header_payg_topup_button_title_label',
  ConfigrationDPcontactTitle: 'DPcontactTitle',
  ConfigrationDPcontactToggle: 'DPcontactToggle',
  ConfigrationDPswitchContactSync: 'DPswitchContactSync',
  ConfigrationDPlocationTitle: 'DPlocationTitle',
  ConfigrationDPlocationToggle: 'DPlocationToggle',
  ConfigrationDPpushTitle: 'DPpushTitle',
  ConfigrationDPpushToggle: 'DPpushToggle',
  ConfigrationSwitchAccessibilityLabel1: 'DPpushSwitch',
  ConfigrationAndroidDPcontactTitle: 'DPcontactTitle',
  ConfigrationAndroidDPcontactToggle: 'DPcontactToggle',
  ConfigrationDPphoneTitle: 'DPphoneTitle',
  ConfigrationDPphoneToggle: 'DPphoneToggle',
  ConfigrationDPusageTitle: 'DPusageTitle',
  ConfigrationDPusageToggle: 'DPusageToggle',
  ConfigrationAndroidDPlocationTitle: 'DPlocationTitle',
  ConfigrationAndroidDPlocationToggle: 'DPlocationToggle',
  ConfigrationAndroidDPpushTitle: 'DPpushTitle',
  ConfigrationAndroidDPpushToggle: 'DPpushToggle',
  NetworkConfigAPnetworkTitle: 'APnetworkTitle',
  NetworkConfigAPnetworkIcon: 'APnetworkIcon',
  NetworkConfigAPnetworkDescription: 'APnetworkDescription',
  NetworkConfigAPnetworkToggle: 'APnetworkToggle',
  ServicesConfigAPpersonalisedTitle: 'APpersonalisedTitle',
  ServicesConfigAPpersonalisedDescription: 'APpersonalisedDescription',
  ServicesConfigAPpersonalisedIcon: 'APpersonalisedIcon',
  ServicesConfigAPpersonalisedToggle: 'APpersonalisedToggle',
  customTabContainer: 'customTabContainer',
  customTabText: 'customTabText',
  customTabViewContainer: 'customTabViewContainer',
  customTabsContainer: 'customTabsContainer',
  NoBalaceHistoryComponentView: 'NoBalaceHistoryComponentView',
  NoBalaceHistoryComponentTitleText: 'NoBalaceHistoryComponentTitleText',
  NoBalaceHistoryComponentSubtitleText: 'NoBalaceHistoryComponentSubtitleText',
  BalanceHistoryBalanceItemsHeaderText: 'BalanceHistoryBalanceItemsHeaderText',
  BalanceHistoryBalanceItemsListView: 'BalanceHistoryBalanceItemsListView',
  BalanceHistoryBalanceItemsList: 'BalanceHistoryBalanceItemsList',
  BalanceHistoryDatesFilterView: 'BalanceHistoryDatesFilterView',
  BalanceHistoryDatesFilterText: 'BalanceHistoryDatesFilterText',
  BalanceHistoryDatesFilterClearButton: 'BalanceHistoryDatesFilterClearButton',
  BalanceHistoryDatesFilterClearButtonText: 'BalanceHistoryDatesFilterClearButtonText',
  BalanceHistoryCategoriesDivider: 'BalanceHistoryCategoriesDivider',
  BalanceHistoryTimePeriodNoBalanceHistoryView: 'BalanceHistoryTimePeriodNoBalanceHistoryView',
  BalanceHistoryTimePeriodNoBalanceHistoryText: 'BalanceHistoryTimePeriodNoBalanceHistoryText',
  balanceItemComponentView: 'balanceItemComponentView',
  balanceItemComponentIconView: 'balanceItemComponentIconView',
  balanceItemComponentIcon: 'balanceItemComponentIcon',
  balanceItemComponentItemDataView: 'balanceItemComponentItemDataView',
  balanceItemComponentBalanceDataView: 'balanceItemComponentBalanceDataView',
  balanceItemComponentTitleText: 'balanceItemComponentTitleText',
  balanceItemComponentDate: 'balanceItemComponentDate',
  balanceItemComponentCallsRightBlockView: 'balanceItemComponentCallsRightBlockView',
  balanceItemComponentCallsPrice: 'balanceItemComponentCallsPrice',
  balanceItemComponentCallsDuration: 'balanceItemComponentCallsDuration',
  balanceItemComponentTopUpRightBlockView: 'balanceItemComponentTopUpRightBlockView',
  balanceItemComponentTopUpPrice: 'balanceItemComponentTopUpPrice',
  balanceItemComponentTopUpStatus: 'balanceItemComponentTopUpStatus',
  balanceItemComponentAddonsRightBlockView: 'balanceItemComponentAddonsRightBlockView',
  balanceItemComponentAddonsPrice: 'balanceItemComponentAddonsPrice',
  balanceItemComponentAddonsRecurringSecondOption:
    'balanceItemComponentAddonsRecurringSecondOption',
  balanceItemComponentAddonsRecurringFirstOption: 'balanceItemComponentAddonsRecurringFirstOption',
  paymentMethodOptionsListTitle: 'paymentMethodOptionListTitle',
  paymentMethodOptionsList: 'paymentMethodOptionsList',
  VoucherTopupConfirmButton: 'voucherTopupConfirmButton',
  VoucherTopupInputText: 'voucherTopupInputText',
  VoucherTopupInputTextError: 'voucherTopupInputTextError',
  qrScannerContainerView: 'qrScannerContainerView',
  qrScannerSubtitle: 'qrScannerSubtitle',
  qrScannerSeparator: 'qrScannerSeparator',
  myPlanTitle: 'myPlanTitle',
  myPlanSubtitle: 'myPlanSubtitle',
  myPlanCardSubtitle: 'myPlanCardSubtitle',
  myPlanCardView: 'myPlanCardView',
  AddOnDetailsBadge: 'AddOnDetailsBadge',
  AddOnDetailsBeforeAmountText: 'AddOnDetailsBeforeAmountText',
  AddOnDetailsAfterAmountText: 'AddOnDetailsAfterAmountText',
  AddOnDetailsDuration: 'AddOnDetailsDuration',
  AddOnDetailsPriceText: 'AddOnDetailsPriceText',
  AddOnDetailsContainer: 'AddOnDetailsContainer',
  AddOnDetailsScrollView: 'AddOnDetailsScrollView',
  AddOnDetailsImage: 'AddOnDetailsImage',
  AddOnDetailsDescriptionView: 'AddOnDetailsDescriptionView',
  AddOnDetailsLowerView: 'AddOnDetailsLowerView',
  AddOnDetailsLowerViewRecordText1: 'AddOnDetailsLowerViewRecordText1',
  AddOnDetailsLowerViewRecordText2: 'AddOnDetailsLowerViewRecordText2',
  AddOnDetailsLowerViewAutoRenewText: 'AddOnDetailsLowerViewAutoRenewText',
  AddOnDetailsLowerViewAutoRenewToggle: 'AddOnDetailsLowerViewAutoRenewToggle',
  settingsPermissionItemContainer: 'settingsPermissionItemContainer',
  settingsPermissionItemContainerView: 'settingsPermissionItemContainerView',
  settingsPermissionItemTO: 'settingsPermissionItemTO',
  settingsPermissionItemDescription: 'settingsPermissionItemDescription',
  settingsOptionCardView: 'settingsOptionCardView',
  settingsOptionItemTO: 'settingsOptionItemTO',
  settingsOptionItemTitleView: 'settingsOptionItemTitleView',
  settingsOptionItemTitleTextView: 'settingsOptionItemTitleTextView',
  settingsOptionItemDescriptionView: 'settingsOptionItemDescriptionView',
  settingsSettingsListTO: 'settingsSettingsListTO',
  settingsSettingsListView: 'settingsSettingsListView',
  settingsSettingsListTextView: 'settingsSettingsListTextView',
  settingsSettingsListTitleText: 'settingsSettingsListTitleText',
  settingsSettingsListIconView: 'settingsSettingsListIconView',
  settingsSettingsListIcon: 'settingsSettingsListIcon',
  settingsSettingsListSectionView: 'settingsSettingsListSectionView',
  settingsSettingsListSectionHeaderView: 'settingsSettingsListSectionHeaderView',
  settingsSettingsListSectionHeaderIconView: 'settingsSettingsListSectionHeaderIconView',
  settingsSettingsListSectionHeaderIcon: 'settingsSettingsListSectionHeaderIcon',
  settingsSettingsListSectionHeaderTextView: 'settingsSettingsListSectionHeaderTextView',
  settingsSettingsListSectionHeaderText: 'settingsSettingsListSectionHeaderText',
  settingsSettingsListSectionItemsContainer: 'settingsSettingsListSectionItemsContainer',
  settingsSettingsListSectionItemsDummyView: 'settingsSettingsListSectionItemsDummyView',
  settingsSettingsListSectionItemsListContainer: 'settingsSettingsListSectionItemsListContainer',
  settingsSettingsListSectionItemsList: 'settingsSettingsListSectionItemsList',
  settingsDisplayOptionsContainerView: 'settingsDisplayOptionsContainerView',
  settingsDisplayOptionsIcon: 'settingsDisplayOptionsIcon',
  settingsDisplayOptionsTextView: 'settingsDisplayOptionsTextView',
  settingsDisplayOptionsTitleText: 'settingsDisplayOptionsTitleText',
  settingsDisplayOptionsDescriptionText: 'settingsDisplayOptionsDescriptionText',
  appSettingsVFScreen: 'appSettingsVFScreen',
  appPermissionsDescriptionView: 'appPermissionsDescriptionView',
  appPermissionsDescriptionText: 'appPermissionsDescriptionText',
  appPermissionsStatusT0: 'appPermissionsStatusT0',
  appPermissionsCard: 'appPermissionsCard',
  appPrivacyCard: 'appPrivacyCard',
  appPrivacyCardView: 'appPrivacyCardView',
  permissionsItemIcon: 'permissionsItemIcon',
  permissionsItemTitle: 'permissionsItemTitle',
  permessionsItemToggleText: 'permessionsItemToggleText',
  permissionsItemSwitch: 'permissionsItemSwitch',
  permissionsItemToggle: 'permissionsItemToggle',
  permissionsItemDescription: 'permissionsItemDescription',
  permissionsItemDescriptionAnimatedView: 'permissionsItemDescriptionAnimatedView',
  permissionsItemHeaderView: 'permissionsItemHeaderView',
  customPermissionsContainer: 'customPermissionsContainer',
  customPermissionsView: 'customPermissionsView',
  customPermissionsSV: 'customPermissionsSV',
  permissionsDescriptionSectionParaghraphText: 'permissionsDescriptionSectionParaghraphText',
  permissionsDescriptionSectionBulletContainer: 'permissionsDescriptionSectionBulletContainer',
  permissionsDescriptionSectionBulletView: 'permissionsDescriptionSectionBulletView',
  permissionsDescriptionSectionBulletText: 'permissionsDescriptionSectionBulletText',
  permissionsDescriptionSectionInfoWholeText: 'permissionsDescriptionSectionInfoWholeText',
  permissionsDescriptionSectionInfoFirstText: 'permissionsDescriptionSectionInfoFirstText',
  permissionsDescriptionSectionInfoSecondText: 'permissionsDescriptionSectionInfoSecondText',
  permissionsDescriptionSectionBreakdownView: 'permissionsDescriptionSectionBreakdownView',
  permissionsDescriptionSectionBreakdownTitleText:
    'permissionsDescriptionSectionBreakdownTitleText',
  permissionsDescriptionSectionBreakdownDescriptionText:
    'permissionsDescriptionSectionBreakdownDescriptionText',
  permissionsDescriptionSectionBreakdownItemTitle:
    'permissionsDescriptionSectionBreakdownItemTitle',
  permissionsDescriptionSectionBreakdownItemDescription:
    'permissionsDescriptionSectionBreakdownItemDescription',
  permissionsDescriptionSectionBreakdownMoreText: 'permissionsDescriptionSectionBreakdownMoreText',
  secondPermissionStepContainerView: 'secondPermissionStepContainerView',
  secondPermissionStepDescriptionView: 'secondPermissionStepDescriptionView',
  secondPermissionStepDescriptionTextView: 'secondPermissionStepDescriptionTextView',
  secondPermissionStepDescriptionIcon: 'secondPermissionStepDescriptionIcon',
  secondPermissionStepButtonContainer: 'secondPermissionStepButtonContainer',
  appPermissionsScrollView: 'appPermissionsScrollView',
  appPermissionsOpenSettingsTWF: 'appPermissionsOpenSettingsTWF',
  displayOptionModeOptionView: 'displayOptionModeOptionView',
  displayOptionModeOptionText: 'displayOptionModeOptionText',
  displayOptionCardContentView: 'displayOptionCardContentView',
  displayOptionCardContentDivider: 'displayOptionCardContentDivider',
  displayOptionCardContentSecondDivider: 'displayOptionCardContentSecondDivider',
  confirmationMenuView: 'confirmationMenuView',
  confirmationMenuMainText: 'confirmationMenuMainText',
  confirmationMenuSubtext: 'confirmationMenuSubtext',
  subTrayErrorAnimatedView: 'subTrayErrorAnimatedView',
  subTrayErrorErrorScreen: 'subTrayErrorErrorScreen',
  trayOverlayAnimatedView: 'trayOverlayAnimatedView',
  trayOverlayTWF: 'trayOverlayTWF',
  trayOverlayView: 'trayOverlayView',
  modalAnimatedView: 'modalAnimatedView',
  modalView: 'modalView',
  modalTitle: 'modalTitle',
  modalCloseBtn: 'modalCloseBtn',
  modalIcon: 'modalIcon',
  modalContentView: 'modalContentView',
  PPOXIconTWF: 'PPO-X-Icon',
  PPOHeaderIcon: 'PPOHeaderIcon',
  PPOHeaderSAV: 'PPOHeaderSAV',
  PPOSectionTitle: 'PPOSectionTitle',
  PPOSectionActionsView: 'PPOSectionActionsView',
  PPOSectionItemsView: 'PPOSectionItemsView',
  PPOSectionItemsIcon: 'PPOSectionItemsIcon',
  PPOSectionItemsTitle: 'PPOSectionItemsTitle',
  PPOPrivacyHeaderTitle: 'PPOPrivacyHeaderTitle',
  PPOIntroText: 'PPOIntroText',
  PPOSettingsTitle: 'PPOSettingsTitle',
  PPOLottie: 'PPOLottie',
  PPOProcessingText: 'PPOProcessingText',
  PPOModal: 'PPOModal',
  PPOModalScrollView: 'PPOModalScrollView',
  BLOScrollView: 'BLOScrollView',
  BLOHintItemView: 'BLOHintItemView',
  BLOHintItemIcon: 'BLOHintItemIcon',
  BLOHintItemText: 'BLOHintItemText',
  BLOHeaderView: 'BLOHeaderView',
  BLOHeaderTWF: 'BLOHeaderTWF',
  BLOHeaderContainerView: 'BLOHeaderContainerView',
  BLOHeaderCloseTWF: 'BLOHeaderCloseTWF',
  BLOHeaderCloseContainer: 'BLOHeaderCloseContainer',
  BLOHeaderCloseIcon: 'BLOHeaderCloseIcon',
  BLOInitialScreenView: 'BLOInitialScreenView',
  BLOInitialIcon: 'BLOInitialIcon',
  BLOInitialScreenTitleText: 'BLOInitialScreenTitleText',
  BLOInitialScreenDescriptionText: 'BLOInitialScreenDescriptionText',
  BLOInitialScreenHintsContainerView: 'BLOInitialScreenHintsContainerView',
  BLOInitialScreenHintItemOne: 'BLOInitialScreenHintItemOne',
  BLOInitialScreenHintItemTwo: 'BLOInitialScreenHintItemTwo',
  BLOInitialScreenLearnMoreTWF: 'BLOInitialScreenLearnMoreTWF',
  BLOInitialScreenLearnMoreText: 'BLOInitialScreenLearnMoreText',
  BLOInitialScreenSettingsText: 'BLOInitialScreenSettingsText',
  BLOInitialScreenAllowAllText: 'BLOInitialScreenAllowAllText',
  BLOInitialScreenSettingsButton: 'BLOInitialScreenSettingsButton',
  BLOInitialScreenNotNowButton: 'BLOInitialScreenNotNowButton',
  BLODetailsScreenView: 'BLODetailsScreenView',
  BLODetailsScreenIcon: 'BLODetailsScreenIcon',
  BLODetailsScreenTitleText: 'BLODetailsScreenTitleText',
  BLODetailsScreenDescriptionText: 'BLODetailsScreenDescriptionText',
  BLODetailsScreenHintsContainerView: 'BLODetailsScreenHintsContainerView',
  BLODetailsScreenHowToTurnOnText: 'BLODetailsScreenHowToTurnOnText',
  BLODetailsScreenSettignsText: 'BLODetailsScreenSettignsText',
  BLODetailsScreenAllowAllText: 'BLODetailsScreenAllowAllText',
  BLODetailsScreenTutorialIcon: 'BLODetailsScreenTutorialIcon',
  BLODetailsScreenSettingsButton: 'BLODetailsScreenSettingsButton',
  BLODetailsScreenTWF: 'BLODetailsScreenTWF',
  BLODetailsScreenPrivacyPolicyText: 'BLODetailsScreenPrivacyPolicyText',
  dashboardErrorCardOuterView: 'dashboardErrorCardOuterView',
  dashboardErrorCardView: 'dashboardErrorCardView',
  dashboardErrorCardActionView: 'dashboardErrorCardActionView',
  dashboardErrorCardActionViewTO: 'dashboardErrorCardActionViewTO',
  editDashboardTilesScreen: 'editDashboardTilesScreen',
  editTertiaryTilesScreen: 'editTertiaryTilesScreen',
  customizeDashboardTilesTitle: 'customizeDashboardTilesTitle',
  customizeDashboardTilesSubtitle: 'customizeDashboardTilesSubtitle',
  customizeDashboardTilesHeaderTitle: 'customizeDashboardTilesHeaderTitle',
  customizeDashboardTilesFooterView: 'customizeDashboardTilesFooterView',
  customizeDashboardTilesFooterText: 'customizeDashboardTilesFooterText',
  customizeDashboardTilesFooterTilesView: 'customizeDashboardTilesFooterTilesView',
  customizeDashboardTilesFlatlist: 'customizeDashboardTilesFlatlist',
  customizeDashboardTilesDividerContainer: 'customizeDashboardTilesDividerContainer',
  customizeDashboardTilesDivider: 'customizeDashboardTilesDivider',
  customizeDashboardTilesButton: 'customizeDashboardTilesButton',
  editDashboardSuccessModal: 'editDashboardSuccessModal',
  editDashboardSuccessModalVFLottie: 'editDashboardSuccessModalVFLottie',
  editDashboardSuccessModalOverlayScreen: 'editDashboardSuccessModalOverlayScreen',
  tileItemIconFlag: 'tileItemIconFlag',
  tileItemIconDemmedFlag: 'tileItemIconDemmedFlag',
  tileItemView: 'tileItemView',
  tileItemTWF: 'tileItemTWF',
  tileItemAddIcon: 'tileItemAddIcon',
  DBdiscoverView: 'DBdiscoverView',
  DBdiscoverViewWrapper: 'DBdiscoverViewWrapper',
  dashboardAnimatedView: 'dashboardAnimatedView',
  dashboardLinearGradientView: 'dashboardLinearGradientView',
  dashboardLinearGradient1: 'dashboardLinearGradient1',
  dashboardLinearGradient2: 'dashboardLinearGradient2',
  dashboardMainCard: 'dashboardMainCard',
  dashboardMainCardsView: 'dashboardMainCardsView',
  dashboardMainCardsSecondaryView: 'dashboardMainCardsSecondaryView',
  dashboardMainCardsAddMoreView: 'dashboardMainCardsAddMoreView',
  dashboardMainCardsFourthView: 'dashboardMainCardsFourthView',
  dashboardDiscoverCardVFT: 'dashboardDiscoverCardVFT',
  dashboardDiscoverCardLoadingView: 'dashboardDiscoverCardLoadingView',
  dashboardDiscoverCardErrorView: 'dashboardDiscoverCardErrorView',
  DBbasicsShowMoreText: 'DBbasicsShowMoreText',
  dashboardListView: 'dashboardListView',
  dashboardListItemView: 'dashboardListItemView',
  dashboardViewAnimatedView: 'dashboardViewAnimatedView',
  dashboardErrorScreen: 'dashboardErrorScreen',
  dashboardEIOViewAnimatedView: 'dashboardEIOViewAnimatedView',
  dashboardSafeAreaView: 'dashboardSafeAreaView',
  dashboardStatusBarView: 'dashboardStatusBarView',
  dashboardLoadingView: 'dashboardLoadingView',
  dashboardFailedFlatList: 'dashboardFailedFlatList',
  dashboardOverlayScreen: 'dashboardOverlayScreen',
  EIODetailsScreenAnimatedMainView: 'EIODetailsScreenAnimatedMainView',
  EIODetailsScreenAnimatedView: 'EIODetailsScreenAnimatedView',
  EIODetailsScreenScrollView: 'EIODetailsScreenScrollView',
  EIODetailsScreenTWF: 'EIODetailsScreenTWF',
  EIOErrorItemView: 'EIOErrorItemView',
  EIOErrorItemDescriptionView: 'EIOErrorItemDescriptionView',
  EIOErrorItemDescriptionBottomContainer: 'EIOErrorItemDescriptionBottomContainer',
  EIOHeaderIcon: 'EIOHeaderIcon',
  EIOHeaderStatusIcon: 'EIOHeaderStatusIcon',
  EIOHeaderAnimatedView: 'EIOHeaderAnimatedView',
  EIOHeaderPuuledAreaView: 'EIOHeaderPuuledAreaView',
  EIOHeaderLogoAndTitleContainerView: 'EIOHeaderLogoAndTitleContainerView',
  EIOHeaderLogoAndTitleContainerTWF: 'EIOHeaderLogoAndTitleContainerTWF',
  EIOHeaderLogoView: 'EIOHeaderLogoView',
  EIOHeaderExpandedTWF: 'EIOHeaderExpandedTWF',
  EIOHeaderTitleContainer: 'EIOHeaderTitleContainer',
  EIOHeaderTitleContainerAnimatedView: 'EIOHeaderTitleContainerAnimatedView',
  EIOHeaderCloseButtonAnimatedView: 'EIOHeaderCloseButtonAnimatedView',
  EIOHeaderCloseButtonIcon: 'EIOHeaderCloseButtonIcon',
  EIOHeaderIconsContainer: 'EIOHeaderIconsContainer',
  dashboardContainerAnimatedFlatlist: 'dashboardContainerAnimatedFlatlist',
  trayLeftBackgroundView: 'trayLeftBackgroundView',
  trayRightBackgroundView: 'trayRightBackgroundView',
  trayLoadingCardView: 'trayLoadingCardView',
  trayLoadingCardMainView: 'trayLoadingCardMainView',
  trayLoadingCardFirstLineView: 'trayLoadingCardFirstLineView',
  trayLoadingCardSecondLineView: 'trayLoadingCardSecondLineView',
  trayLoadingCardCircleView: 'trayLoadingCardCircleView',
  subTrayItemViewBadgeView: 'subTrayItemViewBadgeView',
  subTrayItemViewBadgeRecommendedView: 'subTrayItemViewBadgeRecommendedView',
  subTrayItemViewBadgeRecommendedText: 'subTrayItemViewBadgeRecommendedText',
  subTrayItemViewLockView: 'subTrayItemViewLockView',
  subTrayItemViewLockIcon: 'subTrayItemViewLockIcon',
  subTrayItemViewLockTextContainer: 'subTrayItemViewLockTextContainer',
  subTrayGroupAnimatedViewDescription: 'subTrayGroupAnimatedViewDescription',
  subTrayGroupFooterAnimatedView: 'subTrayGroupFooterAnimatedView',
  subTrayGroupFooterView: 'subTrayGroupFooterView',
  subTrayGroupHeaderAnimatedView: 'subTrayGroupHeaderAnimatedView',
  subTrayGroupHeaderView: 'subTrayGroupHeaderView',
  subTrayGroupHeaderBeforeDescriptionAnimatedView:
    'subTrayGroupHeaderBeforeDescriptionAnimatedView',
  subTrayGroupHeaderBeforeDescriptionView: 'subTrayGroupHeaderBeforeDescriptionView',
  subTrayGroupSecondFlatList: 'subTrayGroupSecondFlatList',
  subTrayGroupExpandedTrayHeaderView: 'subTrayGroupExpandedTrayHeaderView',
  subTrayGroupExpandedTrayHeaderText: 'subTrayGroupExpandedTrayHeaderText',
  subTrayGroupExpandedTrayHeaderButton: 'subTrayGroupExpandedTrayHeaderButton',
  subTrayGroupAnimatedView: 'subTrayGroupAnimatedView',
  subTrayGroupView: 'subTrayGroupView',
  subTrayGroupTabsView: 'subTrayGroupTabsView',
  subTrayGroupTabs: 'subTrayGroupTabs',
  subTrayGroupBottomBarView: 'subTrayGroupBottomBarView',
  customSubTrayItemViewTWF: 'customSubTrayItemViewTWF',
  customSubTrayItemView: 'customSubTrayItemView',
  trayBadgeView: 'trayBadgeView',
  trayBadgeText: 'trayBadgeText',
  trayTabAnimatedImage: 'trayTabAnimatedImage',
  trayTabTWF: 'trayTabTWF',
  trayTabView: 'trayTabView',
  trayTabIconView: 'trayTabIconView',
  trayTabIconContainerView: 'trayTabIconContainerView',
  trayTabIconContainerAnimatedImage: 'trayTabIconContainerAnimatedImage',
  trayTabIconContainerTitle: 'trayTabIconContainerTitle',
  trayTobiCloseAnimatedView: 'trayTobiCloseAnimatedView',
  trayTobiCloseIcon: 'trayTobiCloseIcon',
  trayTobiModal: 'trayTobiModal',
  trayTobiModalAnimatedView: 'trayTobiModalAnimatedView',
  trayTobiModalIcon: 'trayTobiModalIcon',
  trayTobiModalContainerView: 'trayTobiModalContainerView',
  trayTobiModalView: 'trayTobiModalView',
  trayTobiModalLinearGradient: 'trayTobiModalLinearGradient',
  trayLottieView: 'trayLottieView',
  trayBottomBarMainAnimatedView: 'trayBottomBarMainAnimatedView',
  trayBottomBarAnimatedView: 'trayBottomBarAnimatedView',
  trayLottieContainerAnimatedView: 'trayLottieContainerAnimatedView',
  trayLottieContainerView: 'trayLottieContainerView',
  trayLottieContainerBottomView: 'trayLottieContainerBottomView',
  trayCollapseIconAnimatedView: 'trayCollapseIconAnimatedView',
  trayCollapseIconView: 'trayCollapseIconView',
  trayWrapperAnimatedView: 'trayWrapperAnimatedView',
  trayWrapperView: 'trayWrapperView',
  withTrayView: 'withTrayView',
  withTrayContainerView: 'withTrayContainerView',
  stepperViewContainer: 'stepperViewContainer',
  PlanSectionQuickActionMainView: 'planSectionQuickActionMainView',
});
export default FrameworkTestKeys;
